export enum OddLot {
  /** Treat as round lot (default) */
  TreatAsRoundLot = 'N',
  /** Treat as odd lot */
  TreatAsOddLot = 'Y',
}
